export default "__VITE_ASSET__b84c9ad2__"